import LandingPage from "../LandingPage.jsx";

export default function LandingNl() {
  return <LandingPage forcedLang="nl" />;
}